import * as React from 'react';
import type { ParentStudyViewModel } from '../../Semester/ParentStudyViewModel';
import type { OnlineStudySubject } from '../../ViewModel/Subjects/OnlineStudySubject.csharp';
import type { SubjectsTabsTabProps } from '../Tabs/SubjectsTabs';
import { Txt } from '../Txt';
import { Subject } from './SingleSubject/SingleSubject';
import styles from './SingleSubjects.module.css';

interface SingleSubjectsProps extends SubjectsTabsTabProps {
    allAvailableObligatorySubjects: OnlineStudySubject[];
    allAvailableElectiveSubjects: OnlineStudySubject[];
    parentStudy: ParentStudyViewModel;
}

export const SingleSubjects: React.FC<React.PropsWithChildren<SingleSubjectsProps>> = props => {
    const { allAvailableObligatorySubjects: obligatorySubjects, allAvailableElectiveSubjects: electiveSubjects } =
        props;

    return (
        <div className={styles.SingleSubjects}>
            <h3 className={styles.Heading}>
                <Txt id="individualCoursesHelpText" />
            </h3>
            {obligatorySubjects.length > 0 && (
                <div className={styles.CategoryTab}>
                    <h3 className={styles.TabHeading}>
                        <Txt id="obligatorySubjects" />
                    </h3>
                    <ul className={styles.ItemList}>
                        {obligatorySubjects.map(s => (
                            <Subject key={s.code} subject={s} parentStudy={props.parentStudy} />
                        ))}
                    </ul>
                </div>
            )}
            {electiveSubjects.length > 0 && (
                <div className={styles.CategoryTab}>
                    <h3 className={styles.TabHeading}>
                        <Txt id="electiveSubjects" />
                    </h3>
                    <ul className={styles.ItemList}>
                        {electiveSubjects.map(s => (
                            <Subject key={s.code} subject={s} parentStudy={props.parentStudy} />
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
